import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Student } from '../api/models/Student';

/**
 * Not using LoadableResource because I have no idea how to use it 😬
 */
export const studentSlice = createSlice({
  name: 'student',
  initialState: {
    list: [],
    filteredList: [],
    searchTerm: '',
    profile: undefined,
  } as {
    list: Student[];
    profile: Student | undefined;
    filteredList: Student[];
    // TODO: searchTerm is not ideal to be here, refactor
    searchTerm: string;
  },
  reducers: {
    receivedStudent: (state, action: PayloadAction<{ student: Student }>) => {
      state.profile = action.payload.student;
    },
    receivedList: (state, action: PayloadAction<{ list: Student[] }>) => {
      state.list = action.payload.list;
    },
    receivedFilteredList: (state, action: PayloadAction<{ filteredList: Student[] }>) => {
      state.filteredList = action.payload.filteredList;
    },
    receivedSearchTerm: (state, action: PayloadAction<{ searchTerm: string }>) => {
      state.searchTerm = action.payload.searchTerm;
    },
  },
});
